import { Check, X } from "lucide-react";

const rows = [
  { label: "US real estate training (comps, motivation, buy boxes)", elevate: true, generic: false },
  { label: "Dedicated full-time seats (not shared)", elevate: true, generic: false },
  { label: "US business-hour shifts (EST / CST / MST / PST)", elevate: true, generic: false },
  { label: "Weekly KPI scorecard + call QA", elevate: true, generic: false },
  { label: "Replacement guarantee on every role", elevate: true, generic: false },
  { label: "Month-to-month, no long contracts", elevate: true, generic: false },
  { label: "REI CRM expertise (GHL, Podio, FUB)", elevate: true, generic: false },
];

const WhyElevate = () => (
  <section className="section-padding bg-card">
    <div className="container-narrow">
      <div className="max-w-2xl">
        <div className="gold-divider" />
        <h2 className="mt-4 font-display text-3xl font-bold text-foreground md:text-4xl">
          Why investors pick Elevate over a generic outsourcing agency
        </h2>
        <p className="mt-3 text-muted-foreground">
          Most outsourcing shops sell hours. We sell a trained US real estate acquisition function, 
          measured the same way an in-house team is measured.
        </p>
      </div>

      <div className="mt-10 overflow-hidden rounded-2xl border border-border bg-background shadow-sm">
        <div className="grid grid-cols-[1fr_auto_auto] items-center gap-3 border-b border-border bg-muted/50 px-5 py-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground sm:grid-cols-[1.6fr_auto_auto] sm:gap-6 sm:px-8">
          <span>What you get</span>
          <span className="text-primary">Elevate</span>
          <span>Generic VA</span>
        </div>
        {rows.map((r) => (
          <div
            key={r.label}
            className="grid grid-cols-[1fr_auto_auto] items-center gap-3 border-b border-border/60 px-5 py-4 last:border-b-0 sm:grid-cols-[1.6fr_auto_auto] sm:gap-6 sm:px-8"
          >
            <span className="text-sm text-foreground">{r.label}</span>
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary/15 text-secondary">
              {r.elevate ? <Check className="h-4 w-4" /> : <X className="h-4 w-4" />}
            </span>
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-muted text-muted-foreground">
              {r.generic ? <Check className="h-4 w-4" /> : <X className="h-4 w-4" />}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyElevate;
